import { Link } from 'react-router-dom'

function Footer() {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer__grid">
                    <div>
                        <div className="footer__brand">POSTPAID</div>
                        <p className="footer__desc">
                            Connect with micro-influencers and grow your brand.
                            Post it. Get paid. Simple.
                        </p>
                    </div>

                    <div>
                        <h4 className="footer__title">Platform</h4>
                        <Link to="/brands" className="footer__link">For Brands</Link>
                        <Link to="/creators" className="footer__link">For Creators</Link>
                        <Link to="/tools" className="footer__link">Tools</Link>
                        <Link to="/guides" className="footer__link">Guides</Link>
                        <Link to="/blog" className="footer__link">Blog</Link>
                    </div>

                    <div>
                        <h4 className="footer__title">Company</h4>
                        <Link to="/about" className="footer__link">About</Link>
                        <Link to="/contact" className="footer__link">Contact</Link>
                        <Link to="/privacy" className="footer__link">Privacy</Link>
                    </div>

                    <div>
                        <h4 className="footer__title">Learn</h4>
                        <Link to="/help" className="footer__link">Help Center</Link>
                        <Link to="/guides/pay-per-interaction-influencer-marketing" className="footer__link">Pay-Per-Interaction Guide</Link>
                        <Link to="/guides/micro-influencer-marketing" className="footer__link">Micro-Influencer Guide</Link>
                        <Link to="/guides/cpe-benchmarks-2026" className="footer__link">CPE Benchmarks 2026</Link>
                    </div>

                    <div>
                        <h4 className="footer__title">Free tools</h4>
                        <Link to="/tools" className="footer__link">All free tools</Link>
                        <Link to="/tools/engagement-rate-calculator" className="footer__link">Engagement Rate Calculator</Link>
                        <Link to="/tools/creator-earnings-calculator" className="footer__link">Creator Earnings Calculator</Link>
                        <Link to="/tools/campaign-budget-calculator" className="footer__link">Campaign Budget Calculator</Link>
                        <Link to="/tools/disclosure-generator" className="footer__link">#Ad Disclosure Generator</Link>
                        <Link to="/tools/rate-card-generator" className="footer__link">Rate Card Generator</Link>
                    </div>

                    <div>
                        <h4 className="footer__title">Legal</h4>
                        <Link to="/terms" className="footer__link">Terms of Service</Link>
                    </div>
                </div>

                <div className="footer__bottom">
                    <span>(c) 2026 PostPaid. All rights reserved.</span>
                    <div className="flex gap-4">
                        <a href="https://www.instagram.com/postpaidonline/" target="_blank" rel="noopener noreferrer" className="footer__link">Instagram</a>
                        <a href="https://www.tiktok.com/@postpaidonline" target="_blank" rel="noopener noreferrer" className="footer__link">TikTok</a>
                        <a href="https://www.linkedin.com/company/postpaidonline/" target="_blank" rel="noopener noreferrer" className="footer__link">LinkedIn</a>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
